import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import Bus from 'vue-bus'; // https://www.npmjs.com/package/vue-bus

import App from './App.vue';
import router from './router';
import store from './store';

import VueFilter from 'vue-filter'

Vue.use(VueAxios, axios)
Vue.use(Bus)
Vue.use(VueFilter)

Vue.filter('strip', function (value) {
  let regex = /(<([^>]+)>)/ig;
  return value.replace(regex, "");
});

Vue.config.productionTip = false;

// Vue.mixin has to go BEFORE new Vue()
Vue.mixin({
  props: {
    eventName: { // this goes with emitParentEvent method
      type: String,
      default: ''
    }
  },
  methods: {
    broadcast: function (eventName, arg = '') {
      // USAGE: (on component):
      // <a @click="broadcast('component-test-button-click')" class="button-large">Broadcast Test Event</a>
      //
      // event names must be kebab case, e.g. this-is-kebab-case-wow
      // console.log(this.$options.name + ' just broadcast event ' + eventName + ' with arg of ' + arg)
      this.$bus.emit(eventName, arg)
    },
    listenFor: function (eventToListenFor, cb) {
      // USAGE: (on component)
      // mounted: function () {
      //   this.listenFor('component-test-button-click', () => {
      //     this.eventMessage = 'hooray! the event system works!'
      //   })
      // }
      // note that ES6 Arrow functions are required to maintain proper 'this' scope
      // console.log(this.$options.name + ' is listening for event ' + eventToListenFor)
      this.$bus.on(eventToListenFor, arg => {
        // console.log(this.$options.name + ' just received the ' + eventToListenFor + ' event it was listening for, with arg of ' + arg)
        cb(arg)
      })
    },
    emitParentEvent: function (arg = null) {
      // there are some cases where you want generic event behaviors (abstraction, click events on custom components don't trigger for wrapping markup, etc)
      // in these cases, the child component should use emitParentEvent and the parent should pass an eventName prop
      // even in these cases, still use the this.listenFor as you would normally
      if (this.eventName !== '') {
        // console.log(this.$options.name + ' just emitted event ' + this.eventName + ' from  its parent')
        this.$bus.emit(this.eventName, arg)
      } else {
        // console.warn('no parent eventName found!')
      }
    },
  },
})


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');